import React from 'react';
import { MainStyled } from './index.styled';

const Main: React.FC = ({ children }) => {
    return <MainStyled>{children}</MainStyled>;
};

export default Main;
